// State
export const state = {
  COHORTS: 'cohorts',
  COHORT: 'cohort',
  IS_LOADING: 'isLoading',
  COLLECTION: 'collection',
  UNFILTERED_DATA: 'unfilteredData',
  FILTERED_DATA: 'filteredData',
  DATA: 'data',
  INPUT_VARIABLES: 'inputVariables',
  OUTPUT_VARIABLES: 'outputVariables',
  CROSS_FILTER: 'crossFilter',
  DIMENSIONS: 'dimensions',
  PVALS: 'pvals',
  PVALS_REQUEST_NUM: 'pvalsRequestNum',
  PVALS_REQUEST_STATUS: 'pvalsRequestStatus',
  PVALS_REQUEST_DELAY_SECS: 'pvalsRequestDelaySecs',
  PVAL_THRESHOLD: 'pvalThreshold',
  ANOVA_PVALS: 'anovaPvals',
  ANOVA_PVALS_REQUEST_NUM: 'anovaPvalsRequestNum',
  ANOVA_PVALS_REQUEST_STATUS: 'anovaPvalsRequestStatus',
  ANOVA_PVALS_REQUEST_DELAY_SECS: 'anovaPvalsRequestDelaySecs',
  ODDS_RATIO: 'oddsRatio',
  ODDS_RATIO_REQUEST_NUM: 'oddsRatioRequestNum',
  ODDS_RATIO_REQUEST_STATUS: 'oddsRatioRequestStatus',
  ODDS_RATIO_REQUEST_DELAY_SECS: 'oddsRatioRequestDelaySecs',
  QUERIES: 'queries',
  HIGHLIGHTED_SUBSET: 'highlightedSubset',
  COMPARISON_MEASURE: 'comparisonMeasure',
  USE_LONG_SCALE_NAMES: 'useLongScaleNames',
  HELP_MODE: 'helpMode',
  SORT: 'sort',
  SELECTED_ANALYSIS_MODE: 'selectedAnalysisMode',
  CV_METADATA: 'cvMetadata',
  CURRENT_ANALYTICS_TAB: 'currentAnalyticsTab',
};

// Getters
export const getters = {
  HAS_USER_FILTERED_INPUT_VARIABLES: 'hasUserFilteredInputVariables',
  HAS_USER_FILTERED_OUTPUT_VARIABLES: 'hasUserFilteredOutputVariables',
  HAS_USER_SELECTED_COHORT: 'hasUserSelectedCohort',
  FIND_COHORT_QUERY: 'findCohortQuery',
  //  FIND_COHORT_STUDY_INPUT_VARIABLES: 'findCohortStudyInputVariables',
  FIND_COHORT_SUBJECT_INPUT_VARIABLES: 'findCohortSubjectInputVariables',
  FIND_COHORT_OBSERVATION_INPUT_VARIABLES:
    'findCohortObservationInputVariables',
  FIND_COHORT_SUBJECT_OUTPUT_VARIABLES: 'findCohortSubjectOutputVariables',
  FIND_COHORT_OBSERVATION_OUTPUT_VARIABLES:
    'findCohortObservationOutputVariables',
  GET_QUERY: 'getQuery',
};

// Mutations
export const mutations = {
  SET_COHORTS: 'setCohorts',
  SET_COHORT: 'setCohort',
  ADD_COHORT: 'addCohort',
  SET_COLLECTION: 'setCollection',
  SET_LOADING: 'setLoading',
  SET_DATA: 'setData',
  ADD_INPUT_VARIABLE: 'addInputVariable',
  REMOVE_INPUT_VARIABLE: 'removeInputVariable',
  SET_INPUT_VARIABLES: 'setInputVariables',
  REMOVE_OUTPUT_VARIABLE: 'removeOutputVariable',
  SET_OUTPUT_VARIABLES: 'setOutputVariables',
  INITIALIZE_CROSS_FILTER: 'initializeCrossFilter',
  UPDATE_FILTERED_DATA: 'updateDataFromFilters',
  ADD_DIMENSION: 'addDimension',
  REMOVE_DIMENSION: 'removeDimension',
  ADD_FILTER: 'addFilter',
  CLEAR_FILTER: 'clearFilter',
  SET_PVALS: 'setPvals',
  // note - these are missing in mutations.js
  // SET_PVALS_REQUEST_DELAY_SECS: 'setPvalsRequestDelaySecs',
  SET_PVALS_REQUEST_STATUS: 'setPvalsRequestStatus',
  SET_PVAL_THRESHOLD: 'setPvalThreshold',
  SET_ANOVA_PVALS: 'setAnovaPvals',
  // SET_ANOVA_PVALS_REQUEST_DELAY_SECS: 'setAnovaPvalsRequestDelaySecs',
  SET_ANOVA_PVALS_REQUEST_STATUS: 'setAnovaPvalsRequestStatus',
  SET_ODDS_RATIO: 'setOddsRatio',
  SET_ODDS_RATIO_ERROR: 'setOddsRatioError',
  // SET_ODDS_RATIO_REQUEST_DELAY_SECS: 'setOddsRatioRequestDelaySecs',
  SET_ODDS_RATIO_REQUEST_STATUS: 'setOddsRatioRequestStatus',
  SET_HIGHLIGHTED_SUBSET: 'setHighlightedSubset',
  SET_QUERY: 'setQuery',
  CLEAR_QUERY: 'clearQuery',
  RESET_COHORTS: 'resetCohorts',
  RESET_IS_LOADING: 'resetIsLoading',
  RESET_COLLECTION: 'resetCollection',
  RESET_UNFILTERED_DATA: 'resetUnfilteredData',
  RESET_FILTERED_DATA: 'resetFilteredData',
  RESET_INPUT_VARIABLES: 'resetInputVariables',
  RESET_OUTPUT_VARIABLES: 'resetOutputVariables',
  RESET_CROSS_FILTER: 'resetCrossfilter',
  RESET_DIMENSIONS: 'resetDimensions',
  RESET_PVALS: 'resetPvals',
  RESET_ANOVA_PVALS: 'resetAnovaPvals',
  RESET_ODDS_RATIO: 'resetOddsRatio',
  RESET_ODDS_RATIO_ERROR: 'resetOddsRatioError',
  RESET_PVAL_THRESHOLD: 'resetPvalThreshold',
  RESET_HIGHLIGHTED_SUBSET: 'resetHighlightedSubset',
  RESET_QUERIES: 'resetQueries',
  REMOVE_COHORT: 'removeCohort',
  RENAME_COHORT: 'renameCohort',
  INCREMENT_PVALS_REQUEST_NUM: 'incrementPvalsRequestNum',
  INCREMENT_ANOVA_PVALS_REQUEST_NUM: 'incrementAnovaPvalsRequestNum',
  INCREMENT_ODDS_RATIO_REQUEST_NUM: 'incrementOddsRatioRequestNum',
  SET_COMPARISON_MEASURE: 'setComparisonMeasure',
  SET_USE_LONG_SCALE_NAMES: 'setUseLongScaleNames',
  SET_HELP_MODE: 'setHelpMode',
  SET_SORT: 'setSort',
  SET_ANALYSIS_MODE: 'setAnalysisMode',
  SET_CV_METADATA: 'setCvMetadata',
  SET_CURRENT_ANALYTICS_TAB: 'setCurrentAnalyticsTab',
};

// Actions
export const actions = {
  FETCH_COHORTS: 'fetchCohorts',
  SET_COHORT_SUBJECTS: 'setCohortSubjects',
  SET_COHORT: 'setCohort',
  SET_COHORT_OUTCOMEBASED: 'setCohortOutcomeBased',
  SET_COHORT_NO_RESET: 'setCohortNoReset',
  FETCH_COLLECTION: 'fetchCollection',
  FETCH_DATA: 'fetchData',
  ADD_INPUT_VARIABLE: 'addInputVariable',
  REMOVE_INPUT_VARIABLE: 'removeInputVariable',
  SET_INPUT_VARIABLES: 'setInputVariables',
  REMOVE_OUTPUT_VARIABLE: 'removeOutputVariable',
  SET_OUTPUT_VARIABLES: 'setOutputVariables',
  ADD_OUTPUT_VARIABLE: 'addOutputVariable',
  ADD_DIMENSION: 'addDimension',
  ADD_FILTER: 'addFilter',
  CLEAR_FILTER: 'clearFilter',
  ANALYZE_FILTERED: 'analyzeFiltered',
  ANALYZE_COHORTS: 'analyzeCohorts',
  REGRESSION_ANALYSIS_FILTERED: 'regressionAnalysisFiltered',
  ADD_QUERY: 'addQuery',
  RESET_ALL_STORE_DATA: 'resetAllStoreData',
  SAVE_COHORT: 'saveCohort',
  SAVE_SELECTED_COHORT: 'saveSelectedCohort',
  CLEAR_ALL_FILTERS: 'clearAllFilters',
  DELETE_COHORT: 'deleteCohort',
  DELETE_ALL_COHORTS: 'deleteAllCohorts',
  DELETE_SELECTED_COHORT: 'deleteSelectedCohort',
  REMOVE_COHORT: 'removeCohort',
  RENAME_COHORT: 'renameCohort',
  SET_PVAL_THRESHOLD: 'setPvalThreshold',
  RESET_PVAL_THRESHOLD: 'resetPvalThreshold',
  SET_HIGHLIGHTED_SUBSET: 'setHighlightedSubset',
  RESET_HIGHLIGHTED_SUBSET: 'resetHighlightedSubset',
  SET_COMPARISON_MEASURE: 'setComparisonMeasure',
  SET_USE_LONG_SCALE_NAMES: 'setUseLongScaleNames',
  SET_HELP_MODE: 'setHelpMode',
  SET_SORT: 'setSort',
  SET_ANALYSIS_MODE: 'setAnalysisMode',
  FETCH_CV_METADATA: 'fetchCvMetadata',
  SET_CURRENT_ANALYTICS_TAB: 'setCurrentAnalyticsTab',
};
